// These should be overridden by the implementation
const user = {
	userLoggedIn: () => false,
	getUserId: () => null,
	getName: () => null,
	getAccessToken: () => null,
	login: () => new Promise((_resolve, reject) => reject()),
	logout: () => new Promise((_resolve, reject) => reject()),
	getData: (_key) => null,
	setData: (_key, _value) => null
};

export default user;
